export default class paymentHelper {
    static disabled(paymentData) {
        return !paymentData.tr
    }

    static canVoid(paymentData) {
        return !this.disabled(paymentData) && paymentData.isVoidAllowed
    }

    static canRefund(paymentData) {
        return !this.disabled(paymentData) && paymentData.isPartialRefundAllowed
    }

    static canComplete(paymentData) {
        return !this.disabled(paymentData) && paymentData.isCompleteAllowed
    }


    static canNotify(paymentData) {
        return (
            !this.disabled(paymentData) &&
            paymentData.tr.auth_send_notify &&
            (paymentData.tr.payment_method === 'cc' ||
                paymentData.tr.payment_method === 'test' ||
                paymentData.tr.payment_method === 'apple') &&
            (paymentData.tr.status === '4' || paymentData.tr.status === '1') &&
            paymentData.tr.parent_id === '0'
        )
    }
}
